class UserModel {
  constructor(params) {
    this.id = params.id;
    this.displayName = params.displayName;
    this.email = params.email;
  }

  firstNameLetter() {
    return this.displayName[0];
  }

  lastNameLetter() {
    const names = this.displayName.split(' ');
    return names[1][0];
  }

  static fromFirebaseUserModel(firebaseUser) {
    return new UserModel({
      id: firebaseUser.uid,
      displayName: firebaseUser.displayName,
      email: firebaseUser.email,
    });
  }

  static fromString(serialized) {
    const obj = JSON.parse(serialized);

    return new UserModel({
      id: obj.id,
      displayName: obj.displayName,
      email: obj.email,
    });
  }

  serialize() {
    return JSON.stringify({
      id: this.id,
      displayName: this.displayName,
      email: this.email,
    });
  }
}

export default UserModel;
